module.exports = __webpack_public_path__ + "static/media/ZCMD02.810bb792.jpg";